export default "__VITE_ASSET__66fa8053__"